import React from 'react';
import { Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { CornerBadge } from './CornerBadge.styles';
import { pointerCursorSx } from '../../helpers';

interface ContactDateFieldProps {
  value: string | null;
  onChange: (value: string | null) => void;
  visible: boolean;
  required: boolean;
  isSelected: boolean;
  onClick: () => void;
  label?: string;
  options?: Array<{ text: string; value: string; isArchived?: boolean }>;
}

export const ContactDateField: React.FC<ContactDateFieldProps> = ({
  value,
  onChange,
  visible,
  required,
  onClick,
  label,
  options = [],
}) => {

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    if (!visible) return;
    onChange(event.target.value || null);
  };

  return (
    <Box
      onClick={onClick}
      position="relative"
      p={1}
      border={1}
      borderColor="divider"
      borderRadius={1}
      sx={{ cursor: 'pointer', opacity: visible ? 1 : 0.6 }}
    >
      {!visible && (
        <CornerBadge>HIDDEN</CornerBadge>
      )}
      <Typography variant="subtitle2" mb={1} color={visible ? 'inherit' : 'grey.500'}>
        {label || 'Contact Date Type'} {required && <span style={{ color: 'red' }}>*</span>}
      </Typography>
      <Box onClick={onClick} sx={pointerCursorSx}>
        <Select
          label=""
          disabled={false}
          placeholder="Select contact date type"
          value={value ?? ''}
          onChange={handleSelectChange}
          style={{
            width: '100%',
            opacity: visible ? 1 : 0.7
          }}
        >
           {options.map((option) => (
              <MenuItem key={option.value} value={option.value} disabled>
                {option.text}
              </MenuItem>
            ))}
        </Select>
      </Box>
    </Box>
  );
};